export default {
	mobileWidth: 800,
}